"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRMessages = void 0;
var XHRMessages;
(function (XHRMessages) {
    XHRMessages["XHR_FETCH_GENERIC_ERROR"] = "Failed to fetch";
    XHRMessages["XHR_SERVICE_GENERIC_ERROR"] = "Error calling the service";
    XHRMessages["XHR_SERVICE_UNAUTHORIZED"] = "Unauthorized!";
    XHRMessages["XHR_FETCH_NON_BLOB"] = "Error converting response on Blob";
    XHRMessages["XHR_FETCH_NON_JSON"] = "Error converting response on JSON";
    XHRMessages["XHR_FETCH_NON_TEXT"] = "Error converting response on text";
    XHRMessages["XHR_FETCH_NON_TEXT_STREAM"] = "Error converting response on text/event-stream";
})(XHRMessages || (exports.XHRMessages = XHRMessages = {}));
//# sourceMappingURL=messages.js.map